module.exports = __webpack_public_path__ + "img/shopify-limitations-for-e-commerce.f81e1f8b.webp";